/**
 * Os formulários que o franqueado preenche na implantação (chamado New Shoes 2026-0079, F2),
 * espelho de DadosDaImplantacao::CAMPOS no app-api — que é quem decide de verdade o que é
 * obrigatório e válido. Cada formulário está ligado ao item do checklist pela chave.
 */
export type CampoDoFormulario = {
  campo: string;
  rotulo: string;
  obrigatorio: boolean;
  tipo?: 'texto' | 'data' | 'opcoes';
  opcoes?: { ID: string; Name: string }[];
  /** Ocupa a linha inteira. */
  largo?: boolean;
};

export type Formulario = 'dados_pessoais' | 'dados_franquia' | 'dados_bancarios';

const ENDERECO = (uf: string): CampoDoFormulario[] => [
  { campo: 'cep', rotulo: 'CEP', obrigatorio: true },
  { campo: 'endereco', rotulo: 'Endereço', obrigatorio: true, largo: true },
  { campo: 'numero', rotulo: 'Número', obrigatorio: true },
  { campo: 'complemento', rotulo: 'Complemento', obrigatorio: false },
  { campo: 'bairro', rotulo: 'Bairro', obrigatorio: true },
  { campo: 'cidade', rotulo: 'Cidade', obrigatorio: true },
  { campo: uf, rotulo: 'UF', obrigatorio: true },
];

export const CAMPOS: Record<Formulario, CampoDoFormulario[]> = {
  dados_pessoais: [
    { campo: 'nome_completo', rotulo: 'Nome completo', obrigatorio: true, largo: true },
    { campo: 'cpf', rotulo: 'CPF', obrigatorio: true },
    { campo: 'rg', rotulo: 'RG', obrigatorio: false },
    { campo: 'data_nascimento', rotulo: 'Data de nascimento', obrigatorio: false, tipo: 'data' },
    { campo: 'estado_civil', rotulo: 'Estado civil', obrigatorio: false },
    { campo: 'profissao', rotulo: 'Profissão', obrigatorio: false },
    { campo: 'telefone', rotulo: 'Telefone', obrigatorio: true },
    ...ENDERECO('uf'),
  ],
  dados_franquia: [
    { campo: 'nome_fantasia', rotulo: 'Razão social / nome da unidade', obrigatorio: true, largo: true },
    { campo: 'cnpj', rotulo: 'CNPJ', obrigatorio: true },
    { campo: 'inscricao_estadual', rotulo: 'Inscrição estadual', obrigatorio: false },
    { campo: 'telefone', rotulo: 'Telefone da unidade', obrigatorio: true },
    ...ENDERECO('estado'),
  ],
  dados_bancarios: [
    { campo: 'banco', rotulo: 'Banco', obrigatorio: true },
    { campo: 'agencia', rotulo: 'Agência', obrigatorio: true },
    { campo: 'conta', rotulo: 'Conta', obrigatorio: true },
    { campo: 'tipo_conta', rotulo: 'Tipo de conta', obrigatorio: true, tipo: 'opcoes', opcoes: [{ ID: 'corrente', Name: 'Corrente' }, { ID: 'poupanca', Name: 'Poupança' }] },
    { campo: 'titular', rotulo: 'Titular', obrigatorio: true, largo: true },
    { campo: 'documento_titular', rotulo: 'CNPJ ou CPF do titular', obrigatorio: true },
    { campo: 'pix', rotulo: 'Chave PIX', obrigatorio: false },
  ],
};

export const temFormulario = (chave: string | undefined): chave is Formulario => !!chave && chave in CAMPOS;

export type Valores = Record<string, string | null | undefined>;

/** Os obrigatórios ainda vazios. */
export const faltando = (formulario: Formulario, valores: Valores): string[] =>
  CAMPOS[formulario].filter((c) => c.obrigatorio && !(valores[c.campo] ?? '').toString().trim()).map((c) => c.campo);
